import {
    GET_COST_PROVIDER_LOADING,
    GET_COST_PROVIDER_SUCCESS,
    GET_COST_PROVIDER_REJECT,
} from "../../actions/costProvider/getAll";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
}

const costProviderReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_COST_PROVIDER_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_COST_PROVIDER_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_COST_PROVIDER_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        default: return state;
    }
}

export default costProviderReducer